export default function Modal({ title, children, onClose }) {
    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <h4>{title}</h4>
                <hr />
                {children}

                <div className="text-end mt-3">
                    <button className="btn btn-secondary" onClick={onClose}>
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    );
}

const styles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
    },
    modal: {
        background: "#fff",
        padding: "20px",
        borderRadius: "10px",
        width: "600px",
        maxHeight: "90vh",
        overflowY: "auto",
    }
};
